import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FilterData} from "../../filter/interface/filter-data";
import {FilterControls} from "../../filter/interface/filter-controls";
import {Router} from "@angular/router";
import {FabricFilters} from "../../filter/model/fabric-filters";
import {FinishFilters} from "../../filter/model/finish-filters";
import {StoryFilter} from "../../filter/model/story-filter";
import {FilterModule} from "../../filter/filter.module";

@Component({
	selector: 'fb-story-product-filter',
	standalone: true,
	imports: [CommonModule, FilterModule],
	templateUrl: './story-product-filter.component.html',
	styleUrls: ['./story-product-filter.component.scss']
})
export class StoryProductFilterComponent implements OnInit {

	@Input()
	public storyId: number = 0;

	@Input()
	public storyTitle: string = "";
  
	public filterData: FilterData = {
		name: '',
		group: '',
		controls: {} as FilterControls
	};

	constructor(
		private _router: Router
	) {
	}

	ngOnInit(): void {
		this._resolveFilterType();
	}

	private _resolveFilterType(): void {

		this.filterData = {
			name: 'Story Filter',
			group: 'story-product',
			controls: StoryFilter.get()
		};
	}
}
